import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class BinaryButtons extends DesigntimeComponent {
    static staticName = "Buttons (true/false)";
    static staticId = "binaryButtons";
    runtimeValue = null;

    constructor(identifyer) {
        super(identifyer, 2);

        this.disableNextButton();

        this.values = {
            text: new LiquidString("text", `${this.id}_text`),
            trueText: { value: "Yes" },
            falseText: { value: "No" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        if (context.params.useBootstrapUi)
            return this.getRuntimeBootstrapView();

        let $view = $("<div class='sid-clearfix'></div>");

        let $text = $("<div class='sid-question-text'></div>");
        $text.append($("<h3>" + this.values.text.value + "<h3>"));
        $view.append($text);

        let $trueButton = $("<div class='sid-row-button'>" + this.values.trueText.value + "</div>");
        $trueButton.click(function (e) {
            this.runtimeValue = true;
            $(e.currentTarget).parent().find(".sid-button-selected").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.enableNextButton();
        }.bind(this));
        $view.append($trueButton);

        let $falseButton = $("<div class='sid-row-button'>" + this.values.falseText.value + "</div>");
        $falseButton.click(function (e) {
            this.runtimeValue = false;
            $(e.currentTarget).parent().find(".sid-button-selected").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.enableNextButton();
        }.bind(this));
        $view.append($falseButton);

        return $view;
    }

    getRuntimeBootstrapView() {
        let $view = $("<div class='clearfix mb-4 content-binary-buttons'></div>");

        $view.append(this.values.text.getTag("h3"));

        let $trueButton = $(`<button class='btn btn-light m-2'>${this.values.trueText.value}</button>`);
        $trueButton.on("click", function (e) {
            this.runtimeValue = true;
            $(e.currentTarget).parent().find(".active").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.enableNextButton();
        }.bind(this));
        $view.append($trueButton);

        let $falseButton = $(`<button class='btn btn-light m-2'>${this.values.falseText.value}</button>`);
        $falseButton.on("click", function (e) {
            this.runtimeValue = false;
            $(e.currentTarget).parent().find(".active").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.enableNextButton();
        }.bind(this));
        $view.append($falseButton);

        return $view;
    }

    getOutput() {
        return {
            value: this.runtimeValue,
            not_value: !this.runtimeValue
        };
    }

    output = [
        { name: "value", type: "bool" },
        { name: "not_value", type: "bool" }
    ];
}

export { BinaryButtons }
